import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { TribalBoundaryResponse } from "../../shared/models/tribal-boundary.model";
import { TribalBoundaryService } from "../../shared/services/tribal-boundary.service";

@Injectable({
    providedIn: 'root',
})
export class GetTribalBoundaryResolver implements Resolve<TribalBoundaryResponse[]> {

    constructor(
        private tribalBoundaryService: TribalBoundaryService,
    ) { }

    resolve(): Observable<TribalBoundaryResponse[]> {
        return this.tribalBoundaryService.getAll();
    }
}
